import React, { useContext, useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Menu,
  MenuItem,
  Slide,
} from "@mui/material";

import { AiFillEdit } from "react-icons/ai";
import { GoCheckCircleFill } from "react-icons/go";
import { toast } from "react-toastify";

import { MdOutlineSportsSoccer } from "react-icons/md";
import { PaymentAPI } from "../../api/PaymentAPI";
import { AuthContext } from "../auth/AuthContext";
import masterCardLogo from '../../assets/images/mastercard.svg'
import editCard from '../../assets/images/credit-card.png'
import { useSelector } from "react-redux";
import  {PaymentIcon}  from "react-svg-credit-card-payment-icons/dist";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const CardView = ({
  cardDetails,
  defaultCard,
  refreshTrue,
  setSuccess,
  startLoading,
  finishLoading,
  paymentMethodSize,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { userInfo, clubId } = useSelector((store) => store.user)
  const [openDeletePopup, setOpenDeletePopup] = useState(false);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setTimeout(() => {
      setSuccess({ status: '', data: '' })
    }, 4000);
    setAnchorEl(null);
  };

  const removeCardFromUser = async () => {
    try {
      startLoading("loading2");
      const paymentMethodInfo = {
        paymentMethodId: cardDetails.paymentId,
        userId: userInfo.userId,
        clubId: clubId,
      };
      await PaymentAPI.postRemovePaymentMethod(paymentMethodInfo);
      finishLoading("loading2");
      refreshTrue();
    } catch (error) {
      finishLoading("loading2");
      setSuccess({ status: "error", data: error.message });
    }
  };

  const makeDefaultCard = async () => {
    try {
      const setPaymentInfo = {
        userId: userInfo.userId,
        paymentMethodId: cardDetails?.paymentId,
        clubId: clubId,
      };
      startLoading("loading2");
      const res = await PaymentAPI.postSetPaymentDefaultCard(setPaymentInfo);
      setSuccess({ status: "success", data: 'Successfully made default this card' });
      refreshTrue();
      finishLoading("loading2");
    } catch (error) {
      setSuccess({ status: "error", data: 'something went wrong !!' });
      finishLoading("loading2");
    }
  };

 
  return (
    <div
      data-testid="card-view-container"
      className={
        cardDetails?.paymentId === defaultCard
          ? "card-view-container active"
          : "card-view-container"
      }
    >
      {cardDetails?.paymentId === defaultCard && (
        <div data-testid="card-default-check" className="card-default-check">
          <GoCheckCircleFill className="card-default-check-icon" />
        </div>
      )}
      <p>{cardDetails.customerPaymentCardInfo.funding} card</p>
      <div className="card-view-info">
        <PaymentIcon format="flatRounded"  type={cardDetails?.customerPaymentCardInfo?.cardBrand}/>
        <div className="card-secret-number">
          <div className="card-mask">
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
          </div>
          <div className="card-mask">
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
          </div>
          <div className="card-mask">
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
            <MdOutlineSportsSoccer data-testid="card-number" className="card-number" />
          </div>
          <div className="card-last-digit">
            {cardDetails.customerPaymentCardInfo.last4Digits}
          </div>
        </div>
      </div>
      <div data-testid="delete-card-item" className={"delete-card-item"}>
        <img
          src={editCard}
          className="edit-card-button"
          data-testid="edit-card-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        />
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": "basic-button",
          }}
        >
          {cardDetails?.paymentId !== defaultCard && (
            <MenuItem
              onClick={() => {
                makeDefaultCard();
                handleClose();
              }}
            >
              Set default
            </MenuItem>
          )}
          <MenuItem
            onClick={() => {
             // if(cardDetails?.paymentId === defaultCard){
             // setSuccess({ status: "warning", data: "You can't be delete default card" });
             // }
              //else{
             setOpenDeletePopup(true);
             // }
              handleClose();
            }}
          >
            Delete
          </MenuItem>
        </Menu>
      </div>
      <Dialog
        open={openDeletePopup}
        TransitionComponent={Transition}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure to delete this card?"}
        </DialogTitle>
        <DialogActions>
          <div className="member-details-btn">
            <Button onClick={() => setOpenDeletePopup(false)} color="error" variant="outlined">Cancel</Button>
            <Button data-testid="delete-card-btn" onClick={() => {
              setOpenDeletePopup(false);
              removeCardFromUser();
            }} variant="contained">yes</Button>
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CardView;